import React from 'react';
import { Footer, Navbar } from "../components";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 className="mb-4" style={{ borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
            Privacy Policy
          </h1>
          <p><strong>Balvindra Instruments Corporation</strong></p>
          <p><strong>Website:</strong> scientificinstruments.in</p>
          <p><strong>Effective Date:</strong> 10 September 2024</p>

          <p className="mb-4">
            Balvindra Instruments Corporation ("we", "our", "us") operates the website
            <strong> scientificinstruments.in</strong>. This Privacy Policy explains how we
            collect, use, disclose, and safeguard your information.
          </p>

          <h2 className="mt-4 mb-3">1. Information We Collect</h2>
          <ul>
            <li>Personal Information: Name, email address, phone number, billing and shipping address</li>
            <li>Technical Information: IP address, browser type, operating system, cookies</li>
            <li>Transaction Information: Order details and purchase history (excluding card details)</li>
            <li>Communication Data: Enquiries submitted via forms or email</li>
          </ul>

          <h2 className="mt-4 mb-3">2. How We Collect Information</h2>
          <ul>
            <li>Directly through website forms and enquiries</li>
            <li>Automatically via cookies and server logs</li>
          </ul>

          <h2 className="mt-4 mb-3">3. Purpose of Data Collection</h2>
          <ul>
            <li>To process enquiries and orders</li>
            <li>To provide customer support</li>
            <li>To improve our products and services</li>
            <li>To comply with legal obligations</li>
          </ul>

          <h2 className="mt-4 mb-3">4. Legal Basis for Processing</h2>
          <ul>
            <li>User consent</li>
            <li>Performance of contractual obligations</li>
            <li>Compliance with legal requirements</li>
            <li>Legitimate business interests</li>
          </ul>

          <h2 className="mt-4 mb-3">5. Data Storage and Retention</h2>
          <p>
            We store personal data securely and retain it only for as long as necessary to
            fulfill the purposes outlined in this policy or as required by law.
          </p>

          <h2 className="mt-4 mb-3">6. Data Sharing</h2>
          <p>
            We do not sell or rent personal data. Information may be shared with service
            providers or authorities where legally required.
          </p>

          <h2 className="mt-4 mb-3">7. User Rights</h2>
          <p>
            Users may request access, correction, deletion, restriction, or portability of
            their personal data, or withdraw consent.
          </p>

          <h2 className="mt-4 mb-3">8. Cookies</h2>
          <p>
            Cookies are used to improve user experience. You can disable cookies through
            your browser settings.
          </p>

          <h2 className="mt-4 mb-3">9. Data Security</h2>
          <p>
            We implement reasonable technical and organizational measures to protect data
            against unauthorized access or disclosure.
          </p>

          <h2 className="mt-4 mb-3">10. Policy Updates</h2>
          <p>
            This Privacy Policy may be updated periodically. Updates will be posted on this
            page.
          </p>

          <h2 className="mt-4 mb-3">11. Contact Information</h2>
          <p>
            <strong>Balvindra Instruments Corporation</strong><br />
            Email: <a href="mailto:balco@scientificinstruments.in" className="text-decoration-none text-dark">balco@scientificinstruments.in</a><br />
            Address: 3586 Timber Market, Cross Road No. 4, Ambala Cantt, Haryana, India
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;

